import { MigrationDefinition } from '@luzula/luzula-lib';

import { migrationV_1ToV0 } from './migration-v-1-to-v0';
import { migrationV0ToV1 } from './migration-v0-to-v1';
import { migrationV1ToV2 } from './migration-v1-to-v2';
import { migrationV2ToV3 } from './migration-v2-to-v3';
import { migrationV3ToV4 } from './migration-v3-to-v4';
import { migrationV4ToV5 } from './migration-v4-to-v5';
import { migrationV5ToV6 } from './migration-v5-to-v6';
import { migrationV6ToV7 } from './migration-v6-to-v7';
import { migrationV7ToV8 } from './migration-v7-to-v8';
import { migrationV8ToV9 } from './migration-v8-to-v9';
import { migrationV9ToV10 } from './migration-v9-to-v10';
import { migrationV10ToV11 } from './migration-v10-to-v11';
import { migrationV11ToV12 } from './migration-v11-to-v12';
import { migrationV12ToV13 } from './migration-v12-to-v13';
import { migrationV13ToV14 } from './migration-v13-to-v14';
import { migrationV14ToV15 } from './migration-v14-to-v15';
import { migrationV15ToV16 } from './migration-v15-to-v16';
import { migrationV16ToV17 } from './migration-v16-to-v17';

/** Alle Bohrpunkt-Migrationen */
export const ALL_MIGRATIONS: MigrationDefinition[] = [
  migrationV_1ToV0,
  migrationV0ToV1,
  migrationV1ToV2,
  migrationV2ToV3,
  migrationV3ToV4,
  migrationV4ToV5,
  migrationV5ToV6,
  migrationV6ToV7,
  migrationV7ToV8,
  migrationV8ToV9,
  migrationV9ToV10,
  migrationV10ToV11,
  migrationV11ToV12,
  migrationV12ToV13,
  migrationV13ToV14,
  migrationV14ToV15,
  migrationV15ToV16,
  migrationV16ToV17
];
